import React from 'react';
import { useState, useContext } from 'react';
import axios from 'axios';
import API from '../../../lib/api';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import FormState from '../../../components/UI/Form/FormState';
import Button from '../../../components/UI/Button/Button';
import Modal from '../../../components/UI/Modal/Modal';
import Spinner from '../../../components/UI/Spinner/Spinner';
import DataDisplay from './DataDisplay';
import { formActions } from '../../../components/UI/Form/store/forms-reducer';
import { qrcodeActions } from "../../store/qr-code";
import { qrImageActions } from "../../store/qr-image";

// import AuthContext from '../../store/auth-context';
import { getAuthToken } from '../../../components/util/auth';

import * as Coder from 'rxome-generator';

// import { signData } from 'rxome-generator';

// const credentials = {
//     id: ApiDemo.API_ID,
//     user: 'test@rxome.net',
//     key: ApiDemo.API_PRIVATE_KEY
// }

const testPromise = () => {
  return new Promise( (resolve, reject) => {
    resolve( {message: 'ok', status: '666' }); // => Network error
    // reject( {message: 'Shit hapend', response: { data: { message: 'DO YOU SEE THE LIGHT?' }}} ) // response
    //reject( {message: 'Shit hapend', request: 'foo' } ) // no response, but request -> No response from server
    //reject(new Error("Something' wrong"));  // no response, no request -> yield 'request error'
  }) 
};

const SendData = (props) => {
  const [msg, setMsg] = useState( null );
  const [errorMsg, setErrorMsg] = useState( null );
  const [sending, setSending] = useState( false );
  const store = useSelector( state => state );
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const authCtx = useContext(AuthContext);

  const valid =  store.forms.forms.basic?.isValid &&
                 store.forms.forms.consent?.isValid &&
                 !!store.forms.forms.consent?.state.sig_img.value &&
                 (store.qrcode.data || store.img.img);

  let data = null;
  if (valid) {
    const basicdata = Object.fromEntries(Object.entries(store.forms.forms.basic?.state)
                                        .filter( ([k,v]) => !k.startsWith('X'))
                                        .map( ([k,v]) => [k,v.value] ));
    const consentdata = Object.fromEntries(Object.entries(store.forms.forms.consent?.state)
                                        .filter( ([k,v]) => !k.startsWith('X'))
                                        .map( ([k,v]) => [k,v.value] ));
    data = {
              indication: { ...basicdata, ...consentdata }, 
              qrcode: store.qrcode.data,
              image: store.img.img
           };
  }
  
  const sendDataHandler = async () => {
    const token = getAuthToken(); //authCtx.token

    if ( token == null ) {
      setMsg( 'Daten Absenden ist in der Demo nicht möglich.');
      return;
    }

    setSending( true );

    const cfg = API.auth_cfg( token );

    console.log( '[Sending data: ]', data );

    // @TODO: replace DEMO_CREDS
    const publicKey = await Coder.fetchRxomeKey( Coder.DEMO_CREDENTIALS, '' );
    const cryptData = await Coder.encode( publicKey.key, JSON.stringify(data) );
    const msg = { 
      payload: cryptData,
      keyver:  publicKey.version
    }

    // const created = Date.now();
    // const keyId = props.config.user;
    // const user = props.config.user;
    // const keyB64 = props.config.privateKey;
  
    // const auth = await signData( keyId, user, keyB64, created );
  
    axios({ 
      method: 'post',
      baseURL: API.entry,
      url: 'indications.json',
      data: msg,
      ...cfg
      // headers: {		
      //   Authorization: auth,
      //   'x-date': created,
      //   'x-rxome-user': user
      // },
    })
    // testPromise()
    .catch( (error) => {
      // setIsLoading(false);
      let msg=null;
      if (error.response) {
        // Request made and server responded
        if (error.response?.data?.message){
          console.log( '[SendData Response Error] ', error.response.data.message );
          msg=`Response Error: ${error.response.data.message}`;
          console.log(error.response.data);
        } else {
          console.log( '[SendData Response Error] no message' );
          msg='Unknown response error';
        }
        console.log(error.response.status);
        console.log(error.response.headers);
      } else if (error.request) {
        // The request was made but no response was received
        console.log('[SendData Request Error]  ', error.request);
        msg = 'No response from server';
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('[SendData Request Error]  ', error.message);
        msg = `Request Error: ${error.message}`;
      }  
      const err = new Error( `Error sending data: ${msg}` );
      console.log(err.name + ': ' + err.message);
      throw err;
    }) // catch error
    .then( (res) => {
      // setIsLoading(false);
      if (res.status == 201) {
        setMsg('Die Daten wurden erfolgreich übertragen. Sobald eine neue Information für Sie vorliegt, werden Sie per E-Mail darüber informiert. Sie können sich dann hier in Ihrem Nutzeraccount anmelden und die entsprechenden Informationen einsehen.');
        return res.data;
      } else {
        //return res.then((data) => {
          let errorMessage = `${res.status}`;
          if (data && data.error && data.error.message) {
            errorMessage = data.error.message;
          }

          throw new Error( `Network error ${errorMessage}` );
        //});
      }
    })
    .then((data) => {
      console.log( "[SendData result.data: ]", data );
      dispatch( qrImageActions.reset() );
      dispatch( qrcodeActions.reset() );
      // dispatch( formActions.resetForm({ label: "basic" }));
      // dispatch( formActions.resetForm({ label: "consent" }));
    })
    .catch( (err) => {
      setErrorMsg( err.message );
      console.log( err.message )
    })
    .finally( () => {
      setSending( false );
    });

  };
  
  const modalClosedHandler = () => {
    navigate('/submit');
  }

  return <>
    { sending 
      ? <Spinner /> 
      : <> 
          { msg && 
            <Modal show={!!msg}
              modalClosed={ modalClosedHandler }
              className = 'success'>
                <div>{msg}</div>
            </Modal>
          }
          { errorMsg && 
            <Modal show={!!errorMsg}
              modalClosed={() => { setErrorMsg(null) }}
              className = 'error'>
                <div>{errorMsg}</div>
            </Modal>
          }
          { !(store.qrcode.data || store.img.img) && 
                <div style={{margin: "20px 0"}}>
                <span style={{color: "red"}}>
                  Bitte lesen Sie den QR Code im Reiter "QR Code" ein.<br />
                </span>
              </div>
          }
          <FormState label='basic' 
                    fallbackMessage = 'Bitte den Reiter "Patient" ausfüllen.' />
          <FormState label='consent' 
                    fallbackMessage = 'Bitte den Reiter "Einverst." ausfüllen.' />
          <br />
          {valid && 
            <div style={{margin: "20px 0"}}>
              <span style={{color: "#40C0B9"}}>
                Bitte überprüfen Sie Ihre Daten und schließen Sie den Registrierungsprozess ab, indem Sie auf "Daten senden" klicken.<br />
              </span>
              <DataDisplay data={data.indication} qrcode={data.qrcode} hasImage={store.img.img} />
            </div>
          }
          <Button onClick={sendDataHandler}
                  disabled={!valid || sending}
          >
            'Daten senden'
          </Button>
        </>
      }
    </>
}


export default SendData;

/*
      <div>
        { sig && (<img style={{width:'100px'}} src={"data:image/svg+xml;base64," + sig} />) }
      </div>
*/